// @ts-nocheck
import React, { useState } from 'react';
import { Box } from '@mui/material';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import UploadAttachments from '../../../components/UploadAttachments';

const UploadFormFieldPreview = ({ element, answer, handleDirty }) => {
  const [imageFileAttachment, setImageFileAttachment] = useState(answer || []);

  return (
    <Box key={element?.id} m={1}>
      <FieldsInputTitle
        label={element?.label || element?.name}
        isRequired={element?.isRequired}
      />
      <UploadAttachments
        inputId={element?.id}
        attachmentTitle="Click / Drag here to upload files"
        imageFileAttachment={imageFileAttachment}
        setImageFileAttachment={setImageFileAttachment}
        field={element}
        handleDirty={handleDirty}
      />
    </Box>
  );
};

export default UploadFormFieldPreview;
